export const sessionExpire = {
  title: {
    en: "Session Expired",
    mr: "सत्र कालबाह्य झाले",
  },
  message: {
    en: "Your session expired due to inactivity. Please log in again.",
    mr: "निष्क्रियतेमुळे तुमचे सत्र कालबाह्य झाले. कृपया पुन्हा लॉग इन करा.",
  },
  button: {
    en: "Go To Login",
    mr: "लॉगिन वर जा",
  },
};
